angular.module 'zc.master.zcliteReports'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.zcliteReports',
    url: '/zclite_reports'
    views:
      'content@':
        templateUrl: '/templates/master.zclite_reports/list.html'
        controller: 'MasterZcliteReportsListCtrl'



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_reports/routes.coffee